import * as React from "react";

const CENTaxTag: React.FC = () => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M0.375 2.51563C0.375 1.60977 1.10977 0.875 2.01562 0.875H12.9609C13.7086 0.875 14.7527 1.30748 15.2812 1.83594L25.6641 12.2188C26.9455 13.5002 26.9455 15.5779 25.664 16.8594L16.3593 26.1641C15.0779 27.4455 13.0001 27.4455 11.7193 26.164L1.33648 15.7812C0.807481 15.2539 0.375 14.2109 0.375 13.4609V2.51563ZM5.0625 7.4375C5.0625 8.47344 5.90215 9.3125 6.9375 9.3125C7.97285 9.3125 8.8125 8.47344 8.8125 7.4375C8.8125 6.40156 7.97285 5.5625 6.9375 5.5625C5.90215 5.5625 5.0625 6.40039 5.0625 7.4375Z"
                fill="#0F96D9"
            ></path>
        </svg>
    );
};

export default React.memo(CENTaxTag);
